import { programmes } from "@/data/programmes";
export const categories = [
  {
    id: "doctorate",
    slug: "doctorate",
    title: "Doctorate Programmes",
    subtitle: "Professional Doctorates",
    description:
      "Advanced 3-4 year doctoral degrees integrating evidence-based medical science with traditional healing modalities for aspiring physicians.",
    icon: "GraduationCap",
    count: programmes.filter((p) => p.category === "doctorate").length,
  },
  {
    id: "diploma",
    slug: "diploma",
    title: "Diploma Courses",
    subtitle: "Professional Diplomas",
    description:
      "Comprehensive professional training designed to provide deep practical and theoretical expertise in specific natural medicine disciplines.",
    icon: "BookOpen",
    count: programmes.filter((p) => p.category === "diploma").length,
  },
  {
    id: "certificate",
    slug: "certificate",
    title: "Certificate Courses",
    subtitle: "Short-Term Certificates",
    description:
      "Specialized, short-term intensive programmes focused on mastering specific diagnostic techniques and holistic wellness protocols.",
    icon: "Award",
    count: programmes.filter((p) => p.category === "certificate").length,
  },
] as const;
